import React from "react";
import { successLogo } from "../../assets/images";

const Success = ({ setOpenSuccess, setOpenPhoneCheck }: any) => {
  return (
    <div className="fixed inset-0  flex font-manrope justify-start overflow-auto pb-16 items-start pt-16 bg-[#E7EBEE] dark:bg-primary_dark dark:bg-opacity-95  backdrop-blur-sm">
      <div
        className={` w-11/12 mds:w-8/12 md:7/12 border dark:border-[#303030] bg-white  rounded-xl mx-auto p-6 dark:bg-[#192025]   lgss:w-2/5 xxl:w-1/3 `}
      >
        <div className="w-full mt-10 flex justify-center px-3 md:px-6 items-center flex-col gap-4">
          <div className="w-[116px] h-[116px]">
            <img src={successLogo} className="w-full h-full bg-cover" alt="" />
          </div>
          <h4 className="font-sora font-bold text-gray-900 text-center dark:text-gray-100 text-[24px]">
            Phone Number Verified
          </h4>
          <h4 className=" font-medium text-gray-500 dark:text-gray-400 text-center text-[15px]">
            Congratulations! Your phone number has been verified.
          </h4>
        </div>

        <button
          onClick={() => {
            setOpenSuccess(false);
            setOpenPhoneCheck(false);
          }}
          className="mt-28 bg-secondary_button flex justify-center items-center text-white text-[15px] font-medium h-[48px] w-full rounded-xl"
        >
          Continue Trading
        </button>
      </div>
    </div>
  );
};

export default Success;
